<template>
  <div class="tabs comprehensive">
    <div class="search">
      <ElForm inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="name" placeholder="请输入搜索应用名称" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="type" placeholder="应用模式过滤" @change="changeType" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button type="primary" @click="add">添加应用</el-button>
        </ElFormItem>
      </ElForm>
    </div>
    <div>
      <Viewport v-model="tableHeight">
        <el-table class="common-el-table-styles" :data="tableData" border v-loading="loading" :height="tableHeight" style="width: 100%">
          <el-table-column label="应用" width="200px">
            <template slot-scope="{ row }">
              <div class="appInfo">
                <img :src="row.imgUrlRootPath + row.iocnPath" alt="" />
                <div class="info">
                  <el-tooltip class="item" effect="dark" :content="row.gameName" placement="top-start">
                    <p class="title">
                      {{ row.gameName }}
                    </p>
                  </el-tooltip>
                  <p>ID: {{ row.gameId }}</p>
                  <p>
                    <el-button
                      type="text"
                      class="copy"
                      v-clipboard:copy="`ID: ${row.gameId} \nKEY: ${row.gameKey} \nSECRET: ${row.gameSecret}`"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      复制参数
                    </el-button>
                  </p>
                </div>
                <span v-if="row.accessType === 2">
                  <i v-if="row.platform === 1"><Icon type="logo-android"></Icon></i>
                  <i v-else><Icon type="logo-apple"></Icon></i>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="accessType" label="应用模式" width="80px">
            <template slot-scope="{ row }">
              {{ row.accessType === 2 ? '移动追踪' : '聚合追踪' }}
            </template>
          </el-table-column>
          <el-table-column label="支持媒体">
            <template slot-scope="{ row }">
              <p v-for="(media, index) in row.mediaGameName" :key="index">{{ media.mediaName }}：{{ media.mediaGameName }}</p>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="{ row }">
              {{ row.addTime | datetimeToSec }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间">
            <template slot-scope="{ row }">
              {{ row.updateTime | datetimeToSec }}
            </template>
          </el-table-column>
          <el-table-column label="包体状态">
            <template slot-scope="{ row }">
              <div class="uploadState" v-if="row.uploadState === 1">
                <span>
                  <p>{{ row.packageUpTime | datetimeToSec }}</p>
                  <p style="margin-top: 5px">{{ row.packageUpName }}</p>
                </span>
                <a :href="row.packagePathDownUrl" download v-if="row.platform === 1 || row.accessType === 1"
                  ><i class="el-icon-download"></i
                ></a>
              </div>
              <div v-if="row.uploadState === 0">未上传</div>
              <div v-if="row.uploadState === 2">上传中</div>
              <div v-if="row.uploadState === 3">上传失败</div>
            </template>
          </el-table-column>
          <el-table-column label="数据状态">
            <template slot-scope="{ row }">
              {{ row.packageDebugState === 0 ? '未接入' : '正常' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="230px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="access(row)" v-if="row.packageDebugState === 0">接入</el-button>
              <el-button type="text" @click="manager(row)" v-if="row.accessType === 1">管理</el-button>
              <el-button type="text" @click="mediaConfig(row)" v-if="row.accessType === 2">媒体配置</el-button>
              <el-button type="text" @click="update(row)">传包</el-button>
              <el-button type="text" @click="edit(row)">编辑</el-button>
              <el-button type="text" @click="dele(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>

    <!--传包-->
    <uploadDialog
      :isShowDialog="isShowDialog"
      :uploadData="uploadData"
      v-on:closeUploadDialog="closeUploadDialog"
      :pageType="'comprehensive'"
    ></uploadDialog>
    <!--编辑-->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="50%" :before-close="handleClose">
      <div class="editDialog">
        <add-form ref="addForms" :addApplicationForm.sync="addApplicationForm" :isEdit="true"></add-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">退 出</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import addForm from './addForm'
import uploadDialog from './uploadDialog'
import { queryAggregationAppByPage, deleteAggregationApp, updateAggregationApp } from '@/api/sysmana.model'

export default {
  name: 'comperhensive',
  components: {
    uploadDialog,

    addForm
  },
  data() {
    return {
      name: '',
      type: '',
      options: [
        {
          value: 1,
          label: '聚合追踪'
        },
        {
          value: 2,
          label: '移动追踪'
        }
      ],
      tableData: [],
      total: 0,
      tableHeight: 330,
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      isShowDialog: false,
      editDialogVisible: false,
      uploadData: {},
      addApplicationForm: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    add() {
      // 添加综合应用
      window.open('/addapplication/addlayout?name=comprehensive')
    },
    getData() {
      this.loading = true
      this.tableData = []
      queryAggregationAppByPage({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        gameName: this.name,
        accessType: this.type
      }).then((data) => {
        if (data) {
          this.loading = false
          this.total = data.page_info && data.page_info.total_number
          if (typeof data.list !== 'undefined') {
            data.list.forEach((item) => {
              this.tableData.push(item)
            })
          }
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pageSize = size
      this.getData()
    },
    changeType(type) {
      this.type = type
      this.getData()
    },
    search() {
      this.pageIndex = 1
      this.getData()
    },
    closeUploadDialog() {
      this.isShowDialog = false
    },
    access(item) {
      // 接入
      window.open('/addapplication/addlayout?name=comprehensive&row=' + JSON.stringify(item))
    },
    manager(item) {
      // 管理
      this.$emit('changePage', item)
    },
    mediaConfig(item) {
      // 媒体配置
      window.open('/tools/appmanage/add?devGameId=' + item.devGameId + '&t=edit')
    },
    update(item) {
      // 传包
      this.isShowDialog = true
      this.uploadData = item
    },
    edit(item) {
      // 编辑
      const { imgUrlRootPath, iocnPath } = item
      this.editDialogVisible = true
      this.addApplicationForm = item
      this.addApplicationForm.iconPath = imgUrlRootPath + iocnPath
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    dele(item) {
      this.$confirm('确认是否删除该应用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        deleteAggregationApp({
          gameId: item.gameId
        }).then((data) => {
          if (data) {
            this.$message.success('删除成功')
            this.getData()
          }
        })
      })
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    },
    submit() {
      const refForm = this.$refs.addForms
      const { industry, iconPath, gameName, appName, accessType, notifyUrl, gameScale, platform } = refForm.addForm
      const PtomAggregationVo = {
        industry,
        gameId: this.addApplicationForm.gameId,
        devGameId: this.addApplicationForm.devGameId,
        accessType,
        platform,
        appName,
        notifyUrl: notifyUrl || '',
        gameName,
        iconPath: iconPath.split('gameIconImg/')[1],
        newIconPath: iconPath.split('tmp/')[1],
        gameScale: gameScale || 0
      }
      PtomAggregationVo.replaceResourceTemplateList = refForm.getResource()
      this.$refs.addForms.$refs.addForm.validate((valid) => {
        if (valid) {
          updateAggregationApp(PtomAggregationVo).then((data) => {
            if (data) {
              this.editDialogVisible = false
              this.getData()
              this.$message.success('修改成功')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.appInfo {
  i.ivu-icon {
    display: inline-block;
    margin-top: 20px;
    font-size: 20px;
    vertical-align: top;
  }
  img {
    display: inline-block;
    width: 60px;
    height: 60px;
    margin: 0 5px;
    vertical-align: top;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
  }
  .info {
    display: inline-block;
    padding-left: 5px;
    p {
      width: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 8px;
    }
    .copy {
      margin-bottom: 0;
      padding: 0px;
    }
  }
}
.editDialog {
  max-height: 400px;
  overflow-y: scroll;
}
:deep(.el-dialog__body) {
  padding: 0 20px;
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}
.el-button--text {
  padding: 0 0 5px 0;
}
.uploadState {
  span {
    display: inline-block;
    margin-right: 40px;
  }
  a {
    cursor: pointer;
    font-size: 16px;
  }
}
.el-icon-download {
  font-size: 22px;
}
</style>
